var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.742188 13.6497H17.7972",
    stroke: "#14142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741699 6.06641H26.1862",
    stroke: "#14142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741699 21.2329H26.1862",
    stroke: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.32bce18a3ca5de329e89f3f8bd42995d.svg";
export { ForwardRef as ReactComponent };